import React, { forwardRef, memo, useEffect, useRef, useState } from 'react';
import cx from 'classnames';
import cls from './sidenav.module.scss';
import {
  UseNavBar,
  UseNavigation,
  UseSignIn,
  UseUser,
} from 'lb-store/src/hooks';
import { Button, Icon } from 'lb-components';
import { CloseIcon, LargeLogoIcon, ArrowDetails } from '../../assets/icons';
import { NavConfig } from './NavConfig';
import { NavConfig as NavConfigBranches } from './NavConfigBranches';
import _ from 'lodash';
import classNames from 'classnames';
import { CircleSolidIcon, FootballIcon } from '../../assets/icons/menu';

import { i18n, useTranslation } from 'lb-store';
import useTableGames from 'lb-store/src/hooks/useTableGames';
import {LInk as Link} from '../Header/LInk';
let NewNavConfig = NavConfig;
let NewNavConfigBranches = NavConfigBranches;
if (window.location.hostname === "sports.lider-bet.com") {
  NewNavConfig[0].label = 'სპორტი';
  NewNavConfigBranches[0].label = 'სპორტი';

  NewNavConfig=[ { label: 'სპორტი (ძველი ვერსია)', url: `https://www.lider-bet.com/api/?app=togame&game=sport&v=old`, icon: FootballIcon, redirect: true },...NavConfig];
  NewNavConfigBranches=[ { label: 'სპორტი (ძველი ვერსია)', url: `https://www.lider-bet.com/api/?app=togame&game=sport&v=old`, icon: FootballIcon, redirect: true },...NavConfigBranches];
}


const SideNavBar = forwardRef((props, { navContentRef, backdropRef }) => {
  const tableGames = useTableGames();
  const { t } = useTranslation();
  const navRef = useRef(null);
  const menuRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const [activeMenu, setActiveMenu] = useState(-1);
  const lang = i18n.language;
  const { navigate } = UseNavigation();
  const User = UseUser();
  const signIn = UseSignIn();
  const {
    navBarListener,
    Close,
    addListener,
    toggle,
    unsubscribe,
    clientWidth,
  } = UseNavBar(props.callback);
  useEffect(() => {
    const listener = navBarListener.subscribe('navBar', toggle);
    addListener({ navRef, backdropRef, navContentRef, menuRef });
    return () => {
      unsubscribe();
      listener.unsubscribe();
    };
  }, []);



  const concatUrl = (children,url,redirect) => {
    let co = '';
    if(redirect !== undefined){
      co =  url
    }else {
      co = ( children ? '#' : '/'.concat(lang, url))
    }

    return co.replace("{lang}", lang);
  }

  const item = ({
    icon,
    label,
    url,
    badge,
    children,
    iconStyle,
    textStyle,
    key,
    redirect
  }) => {

    //console.log(concatUrl(children,url,redirect));
    return (
      <div
        className={classNames(
          cls.itemWrapper,
          key === activeMenu && cls.active
        )}
        key={key}
      >
        <Link
          redirect={redirect}
          to={concatUrl(children,url,redirect)}
          className={cls.item}
          onClick={(e) => {
            if(redirect) return;
            if (e.ctrlKey) return;
            e.preventDefault();
            if (children) setActiveMenu(key !== activeMenu ? key : -1);
            else {
              navigate('/'+lang.concat(url), true);
              Close();
            }
          }}
        >
          <div
            className={cls.icon}
            style={{
              backgroundImage: `url(${icon})`,
              color: 'white',
              ...iconStyle,
            }}
          />
          <div className={cls.title} style={{ ...textStyle }}>
            {t(label)}
          </div>
          {badge && <span className={cls.badge}>{badge.toUpperCase()}</span>}
          {children && (
            <div className={cls.children}>
              <span>{children.length}</span>
              <Icon
                Icon={ArrowDetails}
                style={{
                  transform: `rotate(${key === activeMenu ? '90deg' : '0'})`,
                }}
              />
            </div>
          )}
        </Link>
        {key === activeMenu && (
          <div className={cls.dropdown}>
            {_.map(children, (c, index) => (
              <span
                key={index}
                onClick={() => {
                  /*if (c.url === '/play/leaderPoker') {
                    User.keepAlive().then((response) => {
                      if (response.status) {
                        window.location.href =
                          Config.TableGames.LeaderPoker.replace(
                            '{platform}',
                            'm'
                          );
                      } else {
                        signIn.open({
                          onSuccess: () =>
                            (window.location.href =
                              Config.TableGames.LeaderPoker.replace(
                                '{platform}',
                                'm'
                              )),
                        });
                      }
                    });
                  } else */if (c.url.indexOf('/play/poker') > -1) {
                    User.keepAlive().then((response) => {
                      if (response.status) {
                        tableGames.playPoker({
                          lang: lang,
                          callback: (url) => {
                            window.open(url, '_self');
                          },
                        });
                      } else {
                        signIn.open({
                          onSuccess: () =>
                            tableGames.playPoker({
                              lang: lang,
                              callback: (url) => {
                                window.open(url, '_self');
                              },
                            }),
                        });
                      }
                    });
                  } else {
                    navigate((lang || 'ka').concat(c.url));
                  }
                  Close();
                }}
              >
                {t(c.label)}
              </span>
            ))}
          </div>
        )}
      </div>
    );
  };
  return (
    <div className={cls.sideNavWrapper}>
      <div className={cx(cls.sideNav)} ref={navRef}>
        <div
          className={cls.sideNavContent}
          style={{ minWidth: `${clientWidth}px` }}
          ref={navContentRef}
        >
          <div className={cls.header}>
            <div
              className={cls.logo}
              style={{ backgroundImage: `url(${LargeLogoIcon})` }}
              onClick={() => {
                navigate('/');
                Close();
              }}
            />
            <div>
              <Button style={{ display: 'flex' }} variant='link'>
                <img
                  src={CloseIcon}
                  alt=''
                  width={16}
                  onClick={() => Close()}
                />
              </Button>
            </div>
          </div>
          <div className={cls.content} ref={menuRef} id={'navbar-content'}>
            {

              _.map(
              User?.User?.data?.branch ? NewNavConfigBranches : NewNavConfig,
              ({ label, url, icon, badge, children,redirect}, key) => {

                return item({
                  icon: icon,
                  label: label,
                  url: url,
                  badge: badge,
                  children: children,
                  key: key,
                  redirect:redirect
                });
              }
            )}
            <hr
              style={{ borderTop: '2px solid #b1bad6', margin: '5px 20px' }}
            />

            {item({
              icon: CircleSolidIcon,
              label: 'სალაროები',
              url: '/branches',
              iconStyle: { width: '1.3rem', height: '1.3rem' },
              textStyle: { fontFamily: 'lbet-nus-regular' },
            })}
            {item({
              icon: CircleSolidIcon,
              label: 'კონტაქტი',
              url: '/contact',
              iconStyle: { width: '1.3rem', height: '1.3rem' },
              textStyle: { fontFamily: 'lbet-nus-regular' },
            })}
            {item({
              icon: CircleSolidIcon,
              label: 'რეგლამენტი',
              url: '/rules',
              iconStyle: { width: '1.3rem', height: '1.3rem' },
              textStyle: { fontFamily: 'lbet-nus-regular' },
            })}
            {item({
              icon: CircleSolidIcon,
              label: 'წესები და პირობები',
              url: '/rules',
              iconStyle: { width: '1.3rem', height: '1.3rem' },
              textStyle: { fontFamily: 'lbet-nus-regular' },
            })}
          </div>
        </div>
      </div>
      <div
        ref={backdropRef}
        onClick={() => Close()}
        className={cx(cls.sideNavBackdrop, {
          [cls.show]: isOpen,
        })}
      />
    </div>
  );
});


export default SideNavBar;
